import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Check, Clock, ExternalLink } from 'lucide-react';

const AffiliateRegisterSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { affiliate_code, affiliate_link, status } = location.state || {};

  if (!affiliate_code) {
    navigate('/affiliate/register');
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl p-8 max-w-2xl w-full">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-yellow-100 mb-6">
            <Clock className="h-12 w-12 text-yellow-600" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">🎉 Registrierung eingereicht!</h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
            Vielen Dank für Ihre Affiliate-Registrierung. Ihre Anmeldung wird derzeit von unserem Team geprüft.
          </p>
          
          <div className="bg-blue-50 rounded-lg p-6 mb-6 text-left">
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-4">📋 Nächste Schritte:</h3>
            <ul className="space-y-3 text-sm text-gray-700 dark:text-gray-300">
              <li className="flex items-start gap-2">
                <span className="text-blue-600 font-bold">1.</span>
                <span>Unser Team prüft Ihre Angaben (dauert in der Regel 1-2 Werktage)</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 font-bold">2.</span>
                <span>Sie erhalten eine E-Mail, sobald Ihr Account freigeschaltet wurde</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 font-bold">3.</span>
                <span>Nach Freischaltung können Sie sofort mit dem Marketing starten</span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6 mb-6 text-left">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Ihr Affiliate-Code:</label>
              <div className="bg-white dark:bg-gray-900 border-2 border-blue-300 rounded-lg p-3 font-mono text-lg font-bold text-blue-600">
                {affiliate_code}
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Ihr Affiliate-Link (nach Freischaltung aktiv):</label>
              <div className="bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-600 rounded-lg p-3 break-all text-sm text-gray-600 dark:text-gray-400">
                {affiliate_link}
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6 text-left">
            <div className="flex">
              <div className="flex-shrink-0">
                <Clock className="h-5 w-5 text-yellow-400" />
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  <strong>Status: Ausstehende Freischaltung</strong><br/>
                  Ihr Affiliate-Link ist derzeit <strong>inaktiv</strong>. Er wird automatisch aktiviert, sobald Ihr Account von unserem Team freigegeben wurde.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => navigate('/')}
              className="flex-1 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 py-3 px-6 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              Zur Startseite
            </button>
            <a
              href="mailto:support@allflowx.com"
              className="flex-1 flex items-center justify-center gap-2 bg-[#0077FF] text-white py-3 px-6 rounded-lg hover:bg-[#0066DD] transition-colors font-medium"
            >
              <ExternalLink className="h-5 w-5" />
              Support kontaktieren
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffiliateRegisterSuccess;